export const CHECKOUT_ENDPOINTS = {
    POST_PAYMENT_INFORMATION: '/checkout/paymentInformation',
    GET_SAVED_CARD: '/checkout/card',
    APPLY_COUPON: '/checkout/applyCoupon',
    GET_REVIEW: '/checkout/review',
} as const;